import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface TFPortalProps {
  className?: string;
  el?: string;
}

const TFPortal: React.FC<TFPortalProps> = ({
  children,
  className = 'root-portal',
  el = 'div',
}) => {
  const [container] = useState(document.createElement(el));

  container.classList.add(className);

  useEffect(() => {
    document.body.appendChild(container);
    return (): void => {
      document.body.removeChild(container);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ReactDOM.createPortal(children, container);
};

export default TFPortal;
